import React, { useEffect, useState, Suspense } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

const ModalFormScore = React.lazy(() =>
  import('../../components/forms/config/modal.form.score'),
);

function ListScores() {
  const [msgGet, setMsgGet] = useState('');
  const [score, setScores] = useState([]);
  const [infocreate, setInfoCreate] = useState({
    typeScore: [],
    pieces: [],
    states: [],
    paints: [],
  });
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });
  useEffect(() => {
    getInfoCreateScore();
    getScores();
  }, []);

  const createScore = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getScores();
  };

  const getScores = async () => {
    const resScore = await get('/config/score/', {});
    if (resScore.success) {
      setScores(resScore.data);
    } else {
      setMsgGet(resScore.message);
    }
  };

  const getInfoCreateScore = async () => {
    const resInfoCreateScore = await get('/config/score/infocreate/', {});
    if (resInfoCreateScore.success) {
      setInfoCreate({ ...resInfoCreateScore.data });
    } else {
      setMsgGet(resInfoCreateScore.message);
    }
  };

  const editButton = (row) => {
    return (
      <ModalFormScore
        infocreate={infocreate}
        title="Modificar Puntuacion"
        button_text="Editar"
        button_variant="outline-primary"
        scoreSelect={row.id}
        callback={createScore}
      ></ModalFormScore>
    );
  };

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && (
        <Alert
          variant="success"
          onClose={() => setAlert({ show: false })}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <Suspense>
        <ModalFormScore
          infocreate={infocreate}
          title="Crear Puntuacion"
          button_text="Crear Puntuacion"
          button_variant="primary"
          callback={createScore}
        ></ModalFormScore>
      </Suspense>
      <ListTables data={score} editar={editButton} messageWd={msgGet} />
    </Base>
  );
}

export default ListScores;
